module.exports = __webpack_public_path__ + "static/media/juancruz.32e2ed1a.jpg";